import { useState } from "react";
import { theme } from "../styles/theme";

function ModalDocente({ onClose, onSave, docentesDisponibles = [] }) {
  const [nombre, setNombre] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!nombre.trim()) {
      return;
    }

    onSave(nombre);
    setNombre("");
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <div>
            <h2 style={styles.title}>Agregar docente</h2>
            <p style={styles.subtitle}>Ingresa un nombre para incorporarlo al catalogo interno.</p>
          </div>

          <button type="button" onClick={onClose} style={styles.closeButton}>
            Cerrar
          </button>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.field}>
            <span style={styles.label}>Nombre del docente</span>
            <input
              type="text"
              value={nombre}
              onChange={(event) => setNombre(event.target.value.toUpperCase())}
              style={styles.input}
              autoFocus
            />
          </label>

          {docentesDisponibles.length > 0 && (
            <p style={styles.helper}>
              Actualmente hay {docentesDisponibles.length} docentes en el catalogo.
            </p>
          )}

          <div style={styles.actions}>
            <button type="button" onClick={onClose} style={styles.secondaryButton}>
              Cancelar
            </button>
            <button type="submit" style={styles.primaryButton}>
              Guardar docente
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalDocente;

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: theme.colors.overlay,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    zIndex: 1200
  },
  modal: {
    width: "min(520px, 100%)",
    background: theme.colors.panelBg,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "18px",
    padding: "24px",
    boxShadow: "0 24px 80px rgba(15, 23, 42, 0.18)"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    marginBottom: "20px"
  },
  title: {
    margin: 0,
    color: theme.colors.text
  },
  subtitle: {
    margin: "8px 0 0",
    color: theme.colors.subtext
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  label: {
    color: theme.colors.subtext,
    fontSize: "14px",
    fontWeight: 600
  },
  input: {
    background: "#f8fbff",
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "10px",
    padding: "12px 14px",
    color: theme.colors.text,
    outline: "none"
  },
  helper: {
    margin: 0,
    color: theme.colors.subtext,
    fontSize: "14px"
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px"
  },
  closeButton: {
    background: "transparent",
    border: `1px solid ${theme.colors.border}`,
    color: theme.colors.text,
    borderRadius: "10px",
    padding: "10px 14px",
    cursor: "pointer"
  },
  secondaryButton: {
    background: "transparent",
    border: `1px solid ${theme.colors.border}`,
    color: theme.colors.text,
    borderRadius: "10px",
    padding: "12px 16px",
    cursor: "pointer"
  },
  primaryButton: {
    background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.headerEnd})`,
    border: "none",
    color: "#fff",
    borderRadius: "10px",
    padding: "12px 16px",
    cursor: "pointer",
    fontWeight: 700
  }
};
